export const notEmpty = ({ t }) => (value) => !value || (value && String(value).trim().length === 0) ? t(`common:validators:strings:required`) : undefined;
export const hasExactlyChars = ({ t, params: charCount }) => (value) => value && value.length !== charCount
    ? t(`common:validators:strings:hasExactlyChars`, { charCount })
    : undefined;
export const isShorterThan = ({ t, params: charCount }) => (value) => value && value.length >= charCount
    ? t(`common:validators:strings:isShorterThan`, { charCount })
    : undefined;
export const isShorterOrEqualThan = ({ t, params: charCount }) => (value) => value && value.length > charCount
    ? t(`common:validators:strings:isShorterOrEqualThan`, { charCount })
    : undefined;
export const isLongerThan = ({ t, params: charCount }) => (value) => value && value.length <= charCount
    ? t(`common:validators:strings:isLongerThan`, { charCount })
    : undefined;
export const isLongerOrEqualThan = ({ t, params: charCount }) => (value) => value && value.length < charCount
    ? t(`common:validators:strings:isLongerOrEqualThan`, { charCount })
    : undefined;
//# sourceMappingURL=validation.strings.js.map